// @flow

export default {
  SUCCESS_STATUSES: ['SETTLED', 'SUBMITTED_FOR_SETTLEMENT'],
  TYPES: {
    BRAINTREE: 'BRAINTREE',
    CHECK: 'CHECK',
  },
}
